import { Plus } from "lucide-react";
import { FC } from "react";

interface DashedAddButtonProps {
  label: string;
  onClick: () => void;
  /** Tighter tile, for narrow containers such as a side panel. */
  compact?: boolean;
  className?: string;
}

/**
 * "Add one more" tile of a list of cards: a dashed outline the whole of which is the button.
 * Same look as the back-office add tiles (AddCollaboratorCard).
 */
export const DashedAddButton: FC<DashedAddButtonProps> = ({ label, onClick, compact = false, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex w-full items-center justify-center gap-3 rounded-xl border-2 border-dashed border-gray-200 bg-white text-center transition-colors hover:border-primary/40 hover:bg-primary/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ${compact ? 'p-4' : 'p-8'} ${className}`}
  >
    <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-primary/10 text-primary">
      <Plus size={18} aria-hidden="true" />
    </span>
    <span className="text-sm font-semibold text-primary">{label}</span>
  </button>
);
